module.exports = __webpack_public_path__ + "img/mwf.98e77e6.png";